import type { Comment } from '../../types';
import { apiClient, handleApiError, type PaginatedItems } from '../api-client';

/**
 * Create a comment
 */
export const createComment = async (
  projectId: string,
  checklistItemNumber: string,
  content: string
): Promise<Comment> => {
  try {
    return apiClient.post<Comment>(`/projects/${projectId}/comments`, {
      checklistItemNumber,
      content,
    });
  } catch (error) {
    return handleApiError(error, 'Error creating comment');
  }
};

/**
 * Get comments for a project
 */
export const getCommentsByProject = async (projectId: string): Promise<PaginatedItems<Comment>> => {
  try {
    return apiClient.getPaginated<Comment>(`/projects/${projectId}/comments`);
  } catch (error) {
    return handleApiError(error, 'Error fetching comments');
  }
};

/**
 * Get comment count for a project
 */
export const getCommentCountByProject = async (projectId: string): Promise<{ count: number }> => {
  try {
    return apiClient.get<{ count: number }>(`/projects/${projectId}/comments/count`);
  } catch (error) {
    return handleApiError(error, 'Error fetching comment count');
  }
};

/**
 * Update a comment
 */
export const updateComment = async (projectId: string, commentId: string, content: string): Promise<Comment> => {
  try {
    return apiClient.put<Comment>(`/projects/${projectId}/comments/${commentId}`, { content });
  } catch (error) {
    return handleApiError(error, 'Error updating comment');
  }
};

/**
 * Delete a comment
 */
export const deleteComment = async (projectId: string, commentId: string): Promise<{ message: string }> => {
  try {
    return apiClient.delete<{ message: string }>(`/projects/${projectId}/comments/${commentId}`);
  } catch (error) {
    return handleApiError(error, 'Error deleting comment');
  }
};
